var r=(...r)=>r.filter((r=>r)).join(" ");export{r as c};
